import {
  SALES_ORDER_LIST,
  SALES_ORDER_LIST_SUCCESS,
  SALES_ORDER_LIST_FAILURE,
  SALES_ORDER_DATA,
  SALES_ORDER_DATA_SUCCESS,
  SALES_ORDER_DATA_FAILURE,
  SALES_ORDER_SEARCH,
  SALES_ORDER_SEARCH_SUCCESS,
  SALES_ORDER_SEARCH_FAILURE,
  SALES_ORDER_CREATE,
  SALES_ORDER_CREATE_SUCCESS,
  SALES_ORDER_CREATE_FAILURE,
  SALES_ORDER_UPDATE,
  SALES_ORDER_UPDATE_SUCCESS,
  SALES_ORDER_UPDATE_FAILURE,
  SALES_ORDER_VOID,
  SALES_ORDER_VOID_SUCCESS,
  SALES_ORDER_VOID_FAILURE,
  SALES_ORDER_PDF,
  SALES_ORDER_PDF_SUCCESS,
  SALES_ORDER_PDF_FAILURE,
  SALES_ORDER_EMAIL_AUTOMATED,
  SALES_ORDER_EMAIL_AUTOMATED_SUCCESS,
  SALES_ORDER_EMAIL_AUTOMATED_FAILURE,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED_SUCCESS,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED_FAILURE,
  SALES_ORDER_DAILY_BALANCE,
  SALES_ORDER_DAILY_BALANCE_SUCCESS,
  SALES_ORDER_DAILY_BALANCE_FAILURE,
  SALES_ORDER_ITEM_SEARCH,
  SALES_ORDER_ITEM_SEARCH_SUCCESS,
  SALES_ORDER_ITEM_SEARCH_FAILURE,
  SALES_ORDER_ITEM_LIST,
  SALES_ORDER_ITEM_LIST_SUCCESS,
  SALES_ORDER_ITEM_LIST_FAILURE,
  SALES_ORDER_STATUS_LIST,
  SALES_ORDER_STATUS_LIST_SUCCESS,
  SALES_ORDER_STATUS_LIST_FAILURE,
  SALES_ORDER_STATUS_DATA,
  SALES_ORDER_STATUS_DATA_SUCCESS,
  SALES_ORDER_STATUS_DATA_FAILURE,
  SALES_ORDER_STATUS_CREATE,
  SALES_ORDER_STATUS_CREATE_SUCCESS,
  SALES_ORDER_STATUS_CREATE_FAILURE,
  SALES_ORDER_STATUS_UPDATE,
  SALES_ORDER_STATUS_UPDATE_SUCCESS,
  SALES_ORDER_STATUS_UPDATE_FAILURE,
  SALES_ORDER_STATUS_DELETE,
  SALES_ORDER_STATUS_DELETE_SUCCESS,
  SALES_ORDER_STATUS_DELETE_FAILURE,
  SALES_ORDER_ACTIVITY_LOG_SEARCH,
  SALES_ORDER_ACTIVITY_LOG_SEARCH_SUCCESS,
  SALES_ORDER_ACTIVITY_LOG_SEARCH_FAILURE,
  SALES_ORDER_CONVERT_TO_INVOICE,
  SALES_ORDER_CONVERT_TO_INVOICE_SUCCESS,
  SALES_ORDER_CONVERT_TO_INVOICE_FAILURE,
  PRODUCT_STOCK_RESERVED_SEARCH,
  PRODUCT_STOCK_RESERVED_SEARCH_SUCCESS,
  PRODUCT_STOCK_RESERVED_SEARCH_FAILURE,
  PRODUCT_STOCK_RESERVED_LIST,
  PRODUCT_STOCK_RESERVED_LIST_SUCCESS,
  PRODUCT_STOCK_RESERVED_LIST_FAILURE,
} from "./actionType";

const initialState = {
  salesOrderList: [],
  salesOrderListLoading: false,
  salesOrderListError: null,

  salesOrderData: [],
  salesOrderDataLoading: false,
  salesOrderDataError: null,

  salesOrderSearch: [],
  salesOrderSearchLoading: false,
  salesOrderSearchError: null,

  salesOrderCreate: [],
  salesOrderCreateLoading: false,
  salesOrderCreateError: null,

  salesOrderUpdate: [],
  salesOrderUpdateLoading: false,
  salesOrderUpdateError: null,

  salesOrderVoid: [],
  salesOrderVoidLoading: false,
  salesOrderVoidError: null,

  salesOrderPdf: [],
  salesOrderPdfLoading: false,
  salesOrderPdfError: null,

  salesOrderEmailAutomated: [],
  salesOrderEmailAutomatedLoading: false,
  salesOrderEmailAutomatedError: null,

  salesOrderEmailResendAutomated: [],
  salesOrderEmailResendAutomatedLoading: false,
  salesOrderEmailResendAutomatedError: null,

  salesOrderDailyBalance: [],
  salesOrderDailyBalanceLoading: false,
  salesOrderDailyBalanceError: null,

  salesOrderItemSearch: [],
  salesOrderItemSearchLoading: false,
  salesOrderItemSearchError: null,

  salesOrderItemList: [],
  salesOrderItemListLoading: false,
  salesOrderItemListError: null,

  salesOrderStatusList: [],
  salesOrderStatusListLoading: false,
  salesOrderStatusListError: null,

  salesOrderStatusData: [],
  salesOrderStatusDataLoading: false,
  salesOrderStatusDataError: null,

  salesOrderStatusCreate: [],
  salesOrderStatusCreateLoading: false,
  salesOrderStatusCreateError: null,

  salesOrderStatusUpdate: [],
  salesOrderStatusUpdateLoading: false,
  salesOrderStatusUpdateError: null,

  salesOrderStatusDelete: [],
  salesOrderStatusDeleteLoading: false,
  salesOrderStatusDeleteError: null,

  salesOrderActivityLogSearch: [],
  salesOrderActivityLogSearchLoading: false,
  salesOrderActivityLogSearchError: null,

  salesOrderConvertToInvoice: [],
  salesOrderConvertToInvoiceLoading: false,
  salesOrderConvertToInvoiceError: null,

  productStockReservedSearch: [],
  productStockReservedSearchLoading: false,
  productStockReservedSearchError: null,

  productStockReservedList: [],
  productStockReservedListLoading: false,
  productStockReservedListError: null,
};

export default function SalesOrder(state = initialState, action) {
  switch (action.type) {
    case SALES_ORDER_LIST:
      return {
        ...state,
        salesOrderListLoading: true,
        salesOrderListError: null,
      };
    case SALES_ORDER_LIST_SUCCESS:
      return {
        ...state,
        salesOrderList: action.payload,
        salesOrderListLoading: false,
        salesOrderListError: null,
      };
    case SALES_ORDER_LIST_FAILURE:
      return {
        ...state,
        salesOrderList: [],
        salesOrderListLoading: false,
        salesOrderListError: action.payload,
      };
    case SALES_ORDER_DATA:
      return {
        ...state,
        salesOrderDataLoading: true,
        salesOrderDataError: null,
      };
    case SALES_ORDER_DATA_SUCCESS:
      return {
        ...state,
        salesOrderData: action.payload,
        salesOrderDataLoading: false,
        salesOrderDataError: null,
      };
    case SALES_ORDER_DATA_FAILURE:
      return {
        ...state,
        salesOrderData: [],
        salesOrderDataLoading: false,
        salesOrderDataError: action.payload,
      };
    case SALES_ORDER_SEARCH:
      return {
        ...state,
        salesOrderSearchLoading: true,
        salesOrderSearchError: null,
      };
    case SALES_ORDER_SEARCH_SUCCESS:
      return {
        ...state,
        salesOrderSearch: action.payload,
        salesOrderSearchLoading: false,
        salesOrderSearchError: null,
      };
    case SALES_ORDER_SEARCH_FAILURE:
      return {
        ...state,
        salesOrderSearch: [],
        salesOrderSearchLoading: false,
        salesOrderSearchError: action.payload,
      };
    case SALES_ORDER_CREATE:
      return {
        ...state,
        salesOrderCreateLoading: true,
        salesOrderCreateError: null,
      };
    case SALES_ORDER_CREATE_SUCCESS:
      return {
        ...state,
        salesOrderCreate: action.payload,
        salesOrderCreateLoading: false,
        salesOrderCreateError: null,
      };
    case SALES_ORDER_CREATE_FAILURE:
      return {
        ...state,
        salesOrderCreate: [],
        salesOrderCreateLoading: false,
        salesOrderCreateError: action.payload,
      };
    case SALES_ORDER_UPDATE:
      return {
        ...state,
        salesOrderUpdateLoading: true,
        salesOrderUpdateError: null,
      };
    case SALES_ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        salesOrderUpdate: action.payload,
        salesOrderUpdateLoading: false,
        salesOrderUpdateError: null,
      };
    case SALES_ORDER_UPDATE_FAILURE:
      return {
        ...state,
        salesOrderUpdate: [],
        salesOrderUpdateLoading: false,
        salesOrderUpdateError: action.payload,
      };
    case SALES_ORDER_VOID:
      return {
        ...state,
        salesOrderVoidLoading: true,
        salesOrderVoidError: null,
      };
    case SALES_ORDER_VOID_SUCCESS:
      return {
        ...state,
        salesOrderVoid: action.payload,
        salesOrderVoidLoading: false,
        salesOrderVoidError: null,
      };
    case SALES_ORDER_VOID_FAILURE:
      return {
        ...state,
        salesOrderVoid: [],
        salesOrderVoidLoading: false,
        salesOrderVoidError: action.payload,
      };
    case SALES_ORDER_PDF:
      return {
        ...state,
        salesOrderPdfLoading: true,
        salesOrderPdfError: null,
      };
    case SALES_ORDER_PDF_SUCCESS:
      return {
        ...state,
        salesOrderPdf: action.payload,
        salesOrderPdfLoading: false,
        salesOrderPdfError: null,
      };
    case SALES_ORDER_PDF_FAILURE:
      return {
        ...state,
        salesOrderPdf: [],
        salesOrderPdfLoading: false,
        salesOrderPdfError: action.payload,
      };
    case SALES_ORDER_EMAIL_AUTOMATED:
      return {
        ...state,
        salesOrderEmailAutomatedLoading: true,
        salesOrderEmailAutomatedError: null,
      };
    case SALES_ORDER_EMAIL_AUTOMATED_SUCCESS:
      return {
        ...state,
        salesOrderEmailAutomated: action.payload,
        salesOrderEmailAutomatedLoading: false,
        salesOrderEmailAutomatedError: null,
      };
    case SALES_ORDER_EMAIL_AUTOMATED_FAILURE:
      return {
        ...state,
        salesOrderEmailAutomated: [],
        salesOrderEmailAutomatedLoading: false,
        salesOrderEmailAutomatedError: action.payload,
      };
    case SALES_ORDER_EMAIL_RESEND_AUTOMATED:
      return {
        ...state,
        salesOrderEmailResendAutomatedLoading: true,
        salesOrderEmailResendAutomatedError: null,
      };
    case SALES_ORDER_EMAIL_RESEND_AUTOMATED_SUCCESS:
      return {
        ...state,
        salesOrderEmailResendAutomated: action.payload,
        salesOrderEmailResendAutomatedLoading: false,
        salesOrderEmailResendAutomatedError: null,
      };
    case SALES_ORDER_EMAIL_RESEND_AUTOMATED_FAILURE:
      return {
        ...state,
        salesOrderEmailResendAutomated: [],
        salesOrderEmailResendAutomatedLoading: false,
        salesOrderEmailResendAutomatedError: action.payload,
      };
    case SALES_ORDER_DAILY_BALANCE:
      return {
        ...state,
        salesOrderDailyBalanceLoading: true,
        salesOrderDailyBalanceError: null,
      };
    case SALES_ORDER_DAILY_BALANCE_SUCCESS:
      return {
        ...state,
        salesOrderDailyBalance: action.payload,
        salesOrderDailyBalanceLoading: false,
        salesOrderDailyBalanceError: null,
      };
    case SALES_ORDER_DAILY_BALANCE_FAILURE:
      return {
        ...state,
        salesOrderDailyBalance: [],
        salesOrderDailyBalanceLoading: false,
        salesOrderDailyBalanceError: action.payload,
      };
    case SALES_ORDER_ITEM_SEARCH:
      return {
        ...state,
        salesOrderItemSearchLoading: true,
        salesOrderItemSearchError: null,
      };
    case SALES_ORDER_ITEM_SEARCH_SUCCESS:
      return {
        ...state,
        salesOrderItemSearch: action.payload,
        salesOrderItemSearchLoading: false,
        salesOrderItemSearchError: null,
      };
    case SALES_ORDER_ITEM_SEARCH_FAILURE:
      return {
        ...state,
        salesOrderItemSearch: [],
        salesOrderItemSearchLoading: false,
        salesOrderItemSearchError: action.payload,
      };
    case SALES_ORDER_ITEM_LIST:
      return {
        ...state,
        salesOrderItemListLoading: true,
        salesOrderItemListError: null,
      };
    case SALES_ORDER_ITEM_LIST_SUCCESS:
      return {
        ...state,
        salesOrderItemList: action.payload,
        salesOrderItemListLoading: false,
        salesOrderItemListError: null,
      };
    case SALES_ORDER_ITEM_LIST_FAILURE:
      return {
        ...state,
        salesOrderItemList: [],
        salesOrderItemListLoading: false,
        salesOrderItemListError: action.payload,
      };
    case SALES_ORDER_STATUS_LIST:
      return {
        ...state,
        salesOrderStatusListLoading: true,
        salesOrderStatusListError: null,
      };
    case SALES_ORDER_STATUS_LIST_SUCCESS:
      return {
        ...state,
        salesOrderStatusList: action.payload,
        salesOrderStatusListLoading: false,
        salesOrderStatusListError: null,
      };
    case SALES_ORDER_STATUS_LIST_FAILURE:
      return {
        ...state,
        salesOrderStatusList: [],
        salesOrderStatusListLoading: false,
        salesOrderStatusListError: action.payload,
      };
    case SALES_ORDER_STATUS_DATA:
      return {
        ...state,
        salesOrderStatusDataLoading: true,
        salesOrderStatusDataError: null,
      };
    case SALES_ORDER_STATUS_DATA_SUCCESS:
      return {
        ...state,
        salesOrderStatusData: action.payload,
        salesOrderStatusDataLoading: false,
        salesOrderStatusDataError: null,
      };
    case SALES_ORDER_STATUS_DATA_FAILURE:
      return {
        ...state,
        salesOrderStatusData: [],
        salesOrderStatusDataLoading: false,
        salesOrderStatusDataError: action.payload,
      };
    case SALES_ORDER_STATUS_CREATE:
      return {
        ...state,
        salesOrderStatusCreateLoading: true,
        salesOrderStatusCreateError: null,
      };
    case SALES_ORDER_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        salesOrderStatusCreate: action.payload,
        salesOrderStatusCreateLoading: false,
        salesOrderStatusCreateError: null,
      };
    case SALES_ORDER_STATUS_CREATE_FAILURE:
      return {
        ...state,
        salesOrderStatusCreate: [],
        salesOrderStatusCreateLoading: false,
        salesOrderStatusCreateError: action.payload,
      };
    case SALES_ORDER_STATUS_UPDATE:
      return {
        ...state,
        salesOrderStatusUpdateLoading: true,
        salesOrderStatusUpdateError: null,
      };
    case SALES_ORDER_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        salesOrderStatusUpdate: action.payload,
        salesOrderStatusUpdateLoading: false,
        salesOrderStatusUpdateError: null,
      };
    case SALES_ORDER_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        salesOrderStatusUpdate: [],
        salesOrderStatusUpdateLoading: false,
        salesOrderStatusUpdateError: action.payload,
      };
    case SALES_ORDER_STATUS_DELETE:
      return {
        ...state,
        salesOrderStatusDeleteLoading: true,
        salesOrderStatusDeleteError: null,
      };
    case SALES_ORDER_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        salesOrderStatusDelete: action.payload,
        salesOrderStatusDeleteLoading: false,
        salesOrderStatusDeleteError: null,
      };
    case SALES_ORDER_STATUS_DELETE_FAILURE:
      return {
        ...state,
        salesOrderStatusDelete: [],
        salesOrderStatusDeleteLoading: false,
        salesOrderStatusDeleteError: action.payload,
      };
    case SALES_ORDER_ACTIVITY_LOG_SEARCH:
      return {
        ...state,
        salesOrderActivityLogSearchLoading: true,
        salesOrderActivityLogSearchError: null,
      };
    case SALES_ORDER_ACTIVITY_LOG_SEARCH_SUCCESS:
      return {
        ...state,
        salesOrderActivityLogSearch: action.payload,
        salesOrderActivityLogSearchLoading: false,
        salesOrderActivityLogSearchError: null,
      };
    case SALES_ORDER_ACTIVITY_LOG_SEARCH_FAILURE:
      return {
        ...state,
        salesOrderActivityLogSearch: [],
        salesOrderActivityLogSearchLoading: false,
        salesOrderActivityLogSearchError: action.payload,
      };
    case SALES_ORDER_CONVERT_TO_INVOICE:
      return {
        ...state,
        salesOrderConvertToInvoiceLoading: true,
        salesOrderConvertToInvoiceError: null,
      };
    case SALES_ORDER_CONVERT_TO_INVOICE_SUCCESS:
      return {
        ...state,
        salesOrderConvertToInvoice: action.payload,
        salesOrderConvertToInvoiceLoading: false,
        salesOrderConvertToInvoiceError: null,
      };
    case SALES_ORDER_CONVERT_TO_INVOICE_FAILURE:
      return {
        ...state,
        salesOrderConvertToInvoice: [],
        salesOrderConvertToInvoiceLoading: false,
        salesOrderConvertToInvoiceError: action.payload,
      };
    case PRODUCT_STOCK_RESERVED_SEARCH:
      return {
        ...state,
        productStockReservedSearchLoading: true,
        productStockReservedSearchError: null,
      };
    case PRODUCT_STOCK_RESERVED_SEARCH_SUCCESS:
      return {
        ...state,
        productStockReservedSearch: action.payload,
        productStockReservedSearchLoading: false,
        productStockReservedSearchError: null,
      };
    case PRODUCT_STOCK_RESERVED_SEARCH_FAILURE:
      return {
        ...state,
        productStockReservedSearch: [],
        productStockReservedSearchLoading: false,
        productStockReservedSearchError: action.payload,
      };
    case PRODUCT_STOCK_RESERVED_LIST:
      return {
        ...state,
        productStockReservedListLoading: true,
        productStockReservedListError: null,
      };
    case PRODUCT_STOCK_RESERVED_LIST_SUCCESS:
      return {
        ...state,
        productStockReservedList: action.payload,
        productStockReservedListLoading: false,
        productStockReservedListError: null,
      };
    case PRODUCT_STOCK_RESERVED_LIST_FAILURE:
      return {
        ...state,
        productStockReservedList: [],
        productStockReservedListLoading: false,
        productStockReservedListError: action.payload,
      };
    default:
      return state;
  }
}
